import { Inject, Injectable } from '@angular/core';
import { Dictionary } from '../../../shared/models/dictionary';
import { EntityTypes } from '../../entity/entity-types';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryCourierService
  extends StoreBaseService<Dictionary> {

  get entityType(): string {
    return EntityTypes.courier;
  }

  get resourceName(): string {
    return 'courier';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
